const config = {
  getTokenFiled () {
    return 'Admin-Token'
  }
}

export default config
